import { render, staticRenderFns } from "./DefectiveProducts.vue?vue&type=template&id=22ee5560&scoped=true&"
import script from "./DefectiveProducts.vue?vue&type=script&lang=js&"
export * from "./DefectiveProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee5560",
  null
  
)

export default component.exports